import { render, staticRenderFns } from "./Votes.vue?vue&type=template&id=29aef9d5&"
import script from "./Votes.vue?vue&type=script&lang=js&"
export * from "./Votes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports